import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import { IMG } from "../data/images";
import { CheckCircle2, ArrowRight } from "lucide-react";

export default function ForAdults() {
  return (
    <>
      <SEO
        title="Cochlear Implant for Adults — A Complete Guide (India)"
        description="Cochlear implant for adults in India. When hearing aids no longer help, single-sided deafness, sudden hearing loss, senior citizens — what to expect from CI."
      />
      <section className="bg-gradient-to-br from-[#F0F9FF] via-white to-[#ECFDF5] py-14">
        <div className="hc-container max-w-4xl">
          <div className="text-[#0F766E] uppercase tracking-wider text-[12px] font-bold mb-3">For adults & seniors</div>
          <h1 className="font-serif text-[2.25rem] md:text-[3rem] font-semibold leading-[1.08] text-slate-900">
            Cochlear Implant for Adults
          </h1>
          <p className="mt-5 text-slate-700 text-[1.08rem] max-w-3xl">
            If hearing aids no longer help you follow conversations, music or phone calls, a cochlear
            implant can restore meaningful hearing — even later in life.
          </p>
        </div>
      </section>

      <section className="hc-container py-14 grid lg:grid-cols-2 gap-12 items-center">
        <img src={IMG.elderlyCouple} alt="Adult with cochlear implant" className="rounded-3xl shadow-md" />
        <div>
          <h2 className="font-serif text-3xl font-semibold text-slate-900 leading-tight">When to consider a CI as an adult</h2>
          <ul className="mt-5 space-y-2.5">
            {[
              "Difficulty following conversations even with hearing aids",
              "Constantly asking people to repeat",
              "Heavy reliance on lip-reading or captions",
              "Sudden hearing loss not improving with hearing aids",
              "Single-sided deafness affecting work and social life",
              "Listening fatigue at the end of the day",
            ].map((s) => <li key={s} className="flex gap-2 text-slate-700"><CheckCircle2 size={18} className="text-[#0F766E] mt-1 shrink-0" />{s}</li>)}
          </ul>
          <div className="mt-7 flex flex-wrap gap-3">
            <Link to="/cochlear-implant-eligibility" className="btn-primary">Check my eligibility</Link>
            <Link to="/register" className="btn-secondary">Speak to a counsellor</Link>
          </div>
        </div>
      </section>

      <section className="bg-slate-50 hc-section">
        <div className="hc-container max-w-4xl">
          <h2 className="font-serif text-3xl font-semibold text-slate-900">Senior citizens & cochlear implants</h2>
          <p className="mt-4 text-slate-700 text-[17px] leading-relaxed">
            Age alone is not a barrier. With medical fitness, senior citizens consistently report
            significant improvements in conversations, phone calls, social participation and quality
            of life after a CI. Surgery is well tolerated under standard anaesthesia.
          </p>
        </div>
      </section>
    </>
  );
}
